"use strict";

var _createForOfIteratorHelper = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Infecter = void 0;

var Infecter = /*#__PURE__*/function () {
  function Infecter(container) {
    _classCallCheck(this, Infecter);

    this.container = container;
  }

  _createClass(Infecter, [{
    key: "isEnabled",
    value: function isEnabled() {
      return this.container.options.infection.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1, delta) {
      var _a, _b;

      var infecter1 = p1.infecter;
      infecter1.updateInfection(delta.value);

      if (infecter1.infectionStage === undefined) {
        return;
      }

      var container = this.container;
      var options = container.options;
      var infectionOptions = options.infection;

      if (!infectionOptions.enable || infectionOptions.stages.length < 1) {
        return;
      }

      var infectionStage1 = infectionOptions.stages[infecter1.infectionStage];
      var pxRatio = container.retina.pixelRatio;
      var radius = p1.getRadius() * 2 + infectionStage1.radius * pxRatio;
      var pos = p1.getPosition();
      var infectedStage1 = (_a = infectionStage1.infectedStage) !== null && _a !== void 0 ? _a : infecter1.infectionStage;
      var query = container.particles.quadTree.queryCircle(pos, radius);
      var infections = infectionStage1.rate;
      var neighbors = query.length;

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p2 = _step.value;

          if (p2 === p1 || p2.destroyed || p2.spawning || !(p2.infecter.infectionStage === undefined || p2.infecter.infectionStage !== infecter1.infectionStage)) {
            continue;
          }

          var infecter2 = p2.infecter;

          if (Math.random() < infections / neighbors) {
            if (infecter2.infectionStage === undefined) {
              infecter2.startInfection(infectedStage1);
            } else if (infecter2.infectionStage < infecter1.infectionStage) {
              infecter2.updateInfectionStage(infectedStage1);
            } else if (infecter2.infectionStage > infecter1.infectionStage) {
              var infectionStage2 = infectionOptions.stages[infecter2.infectionStage];
              var infectedStage2 = (_b = infectionStage2 === null || infectionStage2 === void 0 ? void 0 : infectionStage2.infectedStage) !== null && _b !== void 0 ? _b : infecter2.infectionStage;
              infecter1.updateInfectionStage(infectedStage2);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Infecter;
}();

exports.Infecter = Infecter;